import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles';

const DashBoardRoutes = [
    {
        path: '/dashboard',
        component: React.lazy(() => import('./DashBoard')),
        auth: AuthRoles.admin,
    }
]

export default DashBoardRoutes;
